import queryString from "query-string"
import { reportErrorMessage } from "utils/ErrorReporting"
import Settings from "../utils/CarrotConfig"

export const redirectToSamlExternalLogin = (entityId, employeeIsAdmin, returnUrl) => {
  const defaultAdminUrl = Settings.CARROT_BACKEND_ADMIN_URL
  const redirect = (returnUrl) =>
    window.location.replace(
      Settings.CARROT_BACKEND_URL +
        "/saml2/ExternalLogin?" +
        queryString.stringify({
          returnUrl,
          entityId
        })
    )

  if (!employeeIsAdmin) {
    // handle the case where a member has attempted to access some path like
    // app.get-carrot.com/reimbursements. Since our app will show the login
    // screen, but keep the path the same, we can simply use window.location
    // and they will be properly redirected after authentication
    redirect(window.location)
    return
  }

  const returnUrlFromQueryParam = returnUrl
  if (!returnUrlFromQueryParam) {
    redirect(defaultAdminUrl)
    return
  }

  // Only allow urls to start with allowed Carrot URLs and end with combinations of
  // slashes and alphanumeric characters. This prevents redirecting to potentially
  // malicious URLs e.g. https://admin.get-carrot.com.myfakecarrot.com
  const allowedUrlsRegexes = [
    `^${Settings.CARROT_BACKEND_URL}[/a-zA-Z0-9?=]*$`,
    `^${Settings.CARROT_BACKEND_ADMIN_URL}[/a-zA-Z0-9?=_-]*$`,
    `^${Settings.CARROT_ADMIN_V2_URL}[/a-zA-Z0-9?=_-]*$`
  ]
  const regexMatches = allowedUrlsRegexes.map((regex) => returnUrlFromQueryParam.match(regex))
  const returnUrlIsAllowed = regexMatches.some((match) => match !== null)
  if (!returnUrlIsAllowed) {
    reportErrorMessage(`returnUrl provided at login is not allowed: ${returnUrlFromQueryParam}`)
    redirect(defaultAdminUrl)
    return
  }

  redirect(returnUrlFromQueryParam)
}
